module.exports = __webpack_public_path__ + "static/bground-1c87991c8d344d684cb71f9b52c757d2.jpg";